import React from 'react';
import { observer } from 'mobx-react';

import { formatMoment, readerDayKey } from 'utils/formatters/timezone';
import { DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR, DEFAULT_TIME_FORMAT } from 'core/constants';
import { timezoneStore } from 'stores/Timezone';
import { colors } from 'theme/colors';

import { VersionButton, LatestVersion } from './styles';

const LatestVersionIcon = (): React.ReactNode => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="8" fill={colors.primary.main} />
    <circle cx="8" cy="8" r="5.5" stroke="white" strokeOpacity="0.59" strokeWidth="5" />
  </svg>
);

// With the flag off this keeps the old check, which compares only the day of the month
const isToday = (date: number): boolean =>
  timezoneStore.enabled
    ? readerDayKey(date) === readerDayKey(Date.now())
    : new Date(date).getDate() === new Date().getDate();

const VersionItem = ({
  title,
  date,
  isActive,
  onClick,
  isLatestVersion,
}: {
  title: string;
  date: number;
  isActive: boolean;
  onClick: () => void;
  isLatestVersion: boolean;
}): React.ReactNode => (
  <VersionButton type="button" onClick={onClick} $isActive={isActive} $latestVersion={isLatestVersion}>
    {isLatestVersion && (
      <LatestVersion>
        <LatestVersionIcon />
        <p>Latest version</p>
      </LatestVersion>
    )}
    {title || formatMoment(date, DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR)}
    {/* if it's the same date as the current date, show the time */}
    {title ? (
      <span data-testid="document-version-time">
        {formatMoment(date, isToday(date) ? DEFAULT_TIME_FORMAT : DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR)}
      </span>
    ) : null}
  </VersionButton>
);

export default observer(VersionItem);
